import GenerateAgreement from "../../../jsx/components/Dashboard/LoanApplications/generateagreement";

const GenerateAgreementWrapper = () => {
  return <GenerateAgreement />;
};

export default constore(GenerateAgreementWrapper);
